module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dialogConfig.status) ? _c('div', {
    staticClass: "dialog",
    class: {
      'dialogBG': _vm.dialogConfig.types != 'fail' && _vm.dialogConfig.types != 'succ' ? true : false
    }
  }, [(_vm.dialogConfig.types == 'fail' || _vm.dialogConfig.types == 'succ') ? _c('div', {
    staticClass: "fail"
  }, [_c('div', {
    staticClass: "dialog-content",
    class: {
      'failColor': _vm.dialogConfig.types == 'fail'
    }
  }, [_vm._v(_vm._s(_vm.dialogConfig.mess))])]) : _c('div', {
    staticClass: "dialog-wrapper"
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [_vm._v(_vm._s(_vm.dialogConfig.mess))]), _vm._v(" "), _c('div', {
    staticClass: "border_bottom"
  }), _vm._v(" "), (_vm.dialogConfig.buttons.length > 1) ? _c('div', {
    staticClass: "dialog-btns"
  }, _vm._l((_vm.dialogConfig.buttons), function(button) {
    return _c('div', {
      on: {
        "click": button.affair
      }
    }, [_vm._v(_vm._s(_vm.$t(button.name)))])
  }), 0) : _c('div', {
    staticClass: "dialog-btn"
  }, _vm._l((_vm.dialogConfig.buttons), function(button) {
    return _c('div', {
      on: {
        "click": button.affair
      }
    }, [_vm._v(_vm._s(_vm.$t(button.name)))])
  }), 0)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d18f147c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/modules/dialogs.vue
// module id = 557
// module chunks = 62